import {BeslagType, DraaiType, HengType, Luiksluiting, Luikvastzetter} from "./Model";

/**
 * @param beslagType
 * @param montageType
 * @param draaiType
 * @param hengType
 * @param luiksluiting
 * @param luikvastzetter
 * @returns Item[]
 */
export function Convert(beslagType, montageType, draaiType, hengType, luiksluiting, luikvastzetter) {
    let result = {};
    HengTypeRules.filter(rule =>
        rule.hengType === hengType.type
        && (!rule.hengLengte || rule.hengLengte === hengType.variant)
        && (!rule.draaiType || rule.draaiType === draaiType)
    ).forEach((rule) => {
        AddFromRule(result, rule, beslagType)
    });

    LuiksluitingRules.filter(rule =>
        rule.luiksluiting === luiksluiting
        && (!rule.draaiType || rule.draaiType.includes(draaiType))
    ).forEach((rule: HengTypeRule) => {
        AddFromRule(result, rule, beslagType)
    });

    LuikvastzetterRules.filter(rule =>
        rule.luikvastzetter === luikvastzetter
        && (!rule.draaiType || rule.draaiType.includes(draaiType))
    ).forEach((rule: HengTypeRule) => {
        AddFromRule(result, rule, beslagType)
    });

    const resultArray = [];
    for (const prop in result) {
        if (result.hasOwnProperty(prop)) {
            resultArray.push(result[prop]);
        }
    }

    return sortOnProductNumber(resultArray);
}

function sortOnProductNumber(input) {
    function compare(a, b) {
        const aInt = parseInt(a['id'].replaceAll('-', ''));
        const bInt = parseInt(b['id'].replaceAll('-', ''));
        if (aInt < bInt) {
            return -1;
        }
        if (aInt > bInt) {
            return 1;
        }
        return 0;
    }

    return input.sort(compare);
}


function AddFromRule(result, rule, beslagType) {
    let id = rule.id;
    if (beslagType === BeslagType.OUDHOLLANDS && id.substring(0, 2) === "01") {
        id = "02" + id.substring(2);
    }
    if (!result[id]) {
        if (!ProductList[id]) {
            console.error("Unknown id from client " + id);
        } debugger;
        result[id] = ProductList[id].getDeepCopy();
        let updatedName = window.productNames.find(el => el.name === id);
        if (updatedName != null) {
            result[id].name = updatedName.displayName
        } else {
            console.error("Unknown id from server " + id);
        }
    }
    result[id].amount += rule.amount;
    if (rule.remark) {
        if (result[id].remark) {
            result[id].remark += "\n"
        }
        result[id].remark += rule.remark;
    }
}

class HengTypeRule {
    constructor(hengType, hengLengte, draaiType, amount, id, remark) {
        this._hengType = hengType;
        this._hengLengte = hengLengte;
        this._draaiType = draaiType;
        this._amount = amount;
        this._id = id;
        this._remark = remark;
    }

    get hengType() {
        return this._hengType;
    }

    get hengLengte() {
        return this._hengLengte;
    }

    get draaiType() {
        return this._draaiType;
    }

    get amount() {
        return this._amount;
    }

    get id() {
        return this._id;
    }

    get remark() {
        return this._remark;
    }

    set remark(value) {
        this._remark = value;
    }
}

class LuiksluitingRule {
    constructor(luiksluiting, draaiType: [], amount, id, remark) {
        this._luiksluiting = luiksluiting;
        this._draaiType = draaiType;
        this._amount = amount;
        this._id = id;
        this._remark = remark;
    }


    get luiksluiting() {
        return this._luiksluiting;
    }

    get draaiType(): [] {
        return this._draaiType;
    }

    get amount() {
        return this._amount;
    }

    get id() {
        return this._id;
    }

    get remark() {
        return this._remark;
    }

    set remark(value) {
        this._remark = value;
    }
}

class LuikvastzetterRule {
    constructor(luikvastzetter, draaiType: [], amount, id, remark) {
        this._luikvastzetter = luikvastzetter;
        this._draaiType = draaiType;
        this._amount = amount;
        this._id = id;
        this._remark = remark;
    }


    get luikvastzetter() {
        return this._luikvastzetter;
    }

    get draaiType(): [] {
        return this._draaiType;
    }

    get amount() {
        return this._amount;
    }

    get id() {
        return this._id;
    }

    get remark() {
        return this._remark;
    }

    set remark(value) {
        this._remark = value;
    }
}

const HengTypeRules: HengTypeRule[] = [
    new HengTypeRule(HengType.T2, null, null, 2, "00-02-01"),
    new HengTypeRule(HengType.T2, null, null, 4, "70-10-41"),
    new HengTypeRule(HengType.T2, null, null, 4, "70-10-45"),
    new HengTypeRule(HengType.T2, null, null, 4, "70-90-12"),
    new HengTypeRule(HengType.T2, null, null, 8, "30-10-01"),

    new HengTypeRule(HengType.T2, null, DraaiType.AL, 2, "01-01-10"),
    new HengTypeRule(HengType.T2, null, DraaiType.AL, 2, "01-07-01"),

    new HengTypeRule(HengType.T2, null, DraaiType.AR, 2, "01-01-11"),
    new HengTypeRule(HengType.T2, null, DraaiType.AR, 2, "01-07-02"),

    new HengTypeRule(HengType.T2, null, DraaiType.B, 2, "00-02-01"),
    new HengTypeRule(HengType.T2, null, DraaiType.B, 2, "01-01-10"),
    new HengTypeRule(HengType.T2, null, DraaiType.B, 2, "01-01-11"),
    new HengTypeRule(HengType.T2, null, DraaiType.B, 2, "01-07-01"),
    new HengTypeRule(HengType.T2, null, DraaiType.B, 2, "01-07-02"),
    new HengTypeRule(HengType.T2, null, DraaiType.B, 4, "70-10-41"),
    new HengTypeRule(HengType.T2, null, DraaiType.B, 4, "70-10-45"),
    new HengTypeRule(HengType.T2, null, DraaiType.B, 4, "70-90-12"),
    new HengTypeRule(HengType.T2, null, DraaiType.B, 8, "30-10-01"),

    new HengTypeRule(HengType.T3, null, null, 3, "00-02-01"),
    new HengTypeRule(HengType.T3, null, null, 6, "70-10-41"),
    new HengTypeRule(HengType.T3, null, null, 6, "70-10-45"),
    new HengTypeRule(HengType.T3, null, null, 6, "70-90-12"),
    new HengTypeRule(HengType.T3, null, null, 12, "30-10-01"),

    new HengTypeRule(HengType.T3, null, DraaiType.AL, 3, "01-01-10"),
    new HengTypeRule(HengType.T3, null, DraaiType.AL, 3, "01-07-01"),

    new HengTypeRule(HengType.T3, null, DraaiType.AR, 3, "01-01-11"),
    new HengTypeRule(HengType.T3, null, DraaiType.AR, 3, "01-07-02"),

    new HengTypeRule(HengType.T3, null, DraaiType.B, 3, "00-02-01"),
    new HengTypeRule(HengType.T3, null, DraaiType.B, 3, "01-01-10"),
    new HengTypeRule(HengType.T3, null, DraaiType.B, 3, "01-01-11"),
    new HengTypeRule(HengType.T3, null, DraaiType.B, 3, "01-07-01"),
    new HengTypeRule(HengType.T3, null, DraaiType.B, 3, "01-07-02"),
    new HengTypeRule(HengType.T3, null, DraaiType.B, 6, "70-10-41"),
    new HengTypeRule(HengType.T3, null, DraaiType.B, 6, "70-10-45"),
    new HengTypeRule(HengType.T3, null, DraaiType.B, 6, "70-90-12"),
    new HengTypeRule(HengType.T3, null, DraaiType.B, 12, "30-10-01"),

    new HengTypeRule(HengType.LT3, null, null, 3, "00-02-01"),
    new HengTypeRule(HengType.LT3, null, null, 6, "70-10-41"),
    new HengTypeRule(HengType.LT3, null, null, 6, "70-10-45"),
    new HengTypeRule(HengType.LT3, null, null, 6, "70-90-12"),
    new HengTypeRule(HengType.LT3, null, null, 12, "30-10-01"),

    new HengTypeRule(HengType.LT3, null, DraaiType.AL, 3, "01-01-10"),
    new HengTypeRule(HengType.LT3, null, DraaiType.AL, 1, "01-07-01"),
    new HengTypeRule(HengType.LT3, "200", DraaiType.AL, 2, "01-03-02"),
    new HengTypeRule(HengType.LT3, "300", DraaiType.AL, 2, "01-03-03"),
    new HengTypeRule(HengType.LT3, "300", DraaiType.AL, 2, "70-10-41"),
    new HengTypeRule(HengType.LT3, "300", DraaiType.AL, 2, "30-10-01"),
    new HengTypeRule(HengType.LT3, "400", DraaiType.AL, 2, "01-03-04"),
    new HengTypeRule(HengType.LT3, "400", DraaiType.AL, 4, "70-10-41"),
    new HengTypeRule(HengType.LT3, "400", DraaiType.AL, 4, "30-10-01"),
    new HengTypeRule(HengType.LT3, "500", DraaiType.AL, 2, "01-03-05"),
    new HengTypeRule(HengType.LT3, "500", DraaiType.AL, 6, "70-10-41"),
    new HengTypeRule(HengType.LT3, "500", DraaiType.AL, 6, "30-10-01"),
    new HengTypeRule(HengType.LT3, "600", DraaiType.AL, 2, "01-03-06"),
    new HengTypeRule(HengType.LT3, "600", DraaiType.AL, 8, "70-10-41"),
    new HengTypeRule(HengType.LT3, "600", DraaiType.AL, 8, "30-10-01"),

    new HengTypeRule(HengType.LT3, null, DraaiType.AR, 3, "01-01-11"),
    new HengTypeRule(HengType.LT3, null, DraaiType.AR, 1, "01-07-02"),
    new HengTypeRule(HengType.LT3, "200", DraaiType.AR, 2, "01-03-02"),
    new HengTypeRule(HengType.LT3, "300", DraaiType.AR, 2, "01-03-03"),
    new HengTypeRule(HengType.LT3, "300", DraaiType.AR, 2, "70-10-41"),
    new HengTypeRule(HengType.LT3, "300", DraaiType.AR, 2, "30-10-01"),
    new HengTypeRule(HengType.LT3, "400", DraaiType.AR, 2, "01-03-04"),
    new HengTypeRule(HengType.LT3, "400", DraaiType.AR, 4, "70-10-41"),
    new HengTypeRule(HengType.LT3, "400", DraaiType.AR, 4, "30-10-01"),
    new HengTypeRule(HengType.LT3, "500", DraaiType.AR, 2, "01-03-05"),
    new HengTypeRule(HengType.LT3, "500", DraaiType.AR, 6, "70-10-41"),
    new HengTypeRule(HengType.LT3, "500", DraaiType.AR, 6, "30-10-01"),
    new HengTypeRule(HengType.LT3, "600", DraaiType.AR, 2, "01-03-06"),
    new HengTypeRule(HengType.LT3, "600", DraaiType.AR, 8, "70-10-41"),
    new HengTypeRule(HengType.LT3, "600", DraaiType.AR, 8, "30-10-01"),

    new HengTypeRule(HengType.LT3, null, DraaiType.B, 3, "00-02-01"),
    new HengTypeRule(HengType.LT3, null, DraaiType.B, 6, "70-10-41"),
    new HengTypeRule(HengType.LT3, null, DraaiType.B, 6, "70-10-45"),
    new HengTypeRule(HengType.LT3, null, DraaiType.B, 6, "70-90-12"),
    new HengTypeRule(HengType.LT3, null, DraaiType.B, 12, "30-10-01"),
    new HengTypeRule(HengType.LT3, null, DraaiType.B, 3, "01-01-10"),
    new HengTypeRule(HengType.LT3, null, DraaiType.B, 1, "01-07-01"),
    new HengTypeRule(HengType.LT3, null, DraaiType.B, 3, "01-01-11"),
    new HengTypeRule(HengType.LT3, null, DraaiType.B, 1, "01-07-02"),
    new HengTypeRule(HengType.LT3, "200", DraaiType.B, 4, "01-03-02"),
    new HengTypeRule(HengType.LT3, "300", DraaiType.B, 4, "01-03-03"),
    new HengTypeRule(HengType.LT3, "300", DraaiType.B, 4, "70-10-41"),
    new HengTypeRule(HengType.LT3, "300", DraaiType.B, 4, "30-10-01"),
    new HengTypeRule(HengType.LT3, "400", DraaiType.B, 4, "01-03-04"),
    new HengTypeRule(HengType.LT3, "400", DraaiType.B, 8, "70-10-41"),
    new HengTypeRule(HengType.LT3, "400", DraaiType.B, 8, "30-10-01"),
    new HengTypeRule(HengType.LT3, "500", DraaiType.B, 4, "01-03-05"),
    new HengTypeRule(HengType.LT3, "500", DraaiType.B, 12, "70-10-41"),
    new HengTypeRule(HengType.LT3, "500", DraaiType.B, 12, "30-10-01"),
    new HengTypeRule(HengType.LT3, "600", DraaiType.B, 4, "01-03-06"),
    new HengTypeRule(HengType.LT3, "600", DraaiType.B, 16, "70-10-41"),
    new HengTypeRule(HengType.LT3, "600", DraaiType.B, 16, "30-10-01"),

    new HengTypeRule(HengType.L2, null, null, 2, "00-02-01"),
    new HengTypeRule(HengType.L2, null, null, 4, "70-10-41"),
    new HengTypeRule(HengType.L2, null, null, 4, "70-10-45"),
    new HengTypeRule(HengType.L2, null, null, 4, "70-90-12"),
    new HengTypeRule(HengType.L2, null, null, 8, "30-10-01"),

    new HengTypeRule(HengType.L2, null, DraaiType.AL, 2, "01-01-10"),
    new HengTypeRule(HengType.L2, "200", DraaiType.AL, 2, "01-03-02"),
    new HengTypeRule(HengType.L2, "300", DraaiType.AL, 2, "01-03-03"),
    new HengTypeRule(HengType.L2, "300", DraaiType.AL, 2, "70-10-41"),
    new HengTypeRule(HengType.L2, "300", DraaiType.AL, 2, "30-10-01"),
    new HengTypeRule(HengType.L2, "400", DraaiType.AL, 2, "01-03-04"),
    new HengTypeRule(HengType.L2, "400", DraaiType.AL, 4, "70-10-41"),
    new HengTypeRule(HengType.L2, "400", DraaiType.AL, 4, "30-10-01"),
    new HengTypeRule(HengType.L2, "500", DraaiType.AL, 2, "01-03-05"),
    new HengTypeRule(HengType.L2, "500", DraaiType.AL, 6, "70-10-41"),
    new HengTypeRule(HengType.L2, "500", DraaiType.AL, 6, "30-10-01"),
    new HengTypeRule(HengType.L2, "600", DraaiType.AL, 2, "01-03-06"),
    new HengTypeRule(HengType.L2, "600", DraaiType.AL, 8, "70-10-41"),
    new HengTypeRule(HengType.L2, "600", DraaiType.AL, 8, "30-10-01"),

    new HengTypeRule(HengType.L2, null, DraaiType.AR, 2, "01-01-11"),
    new HengTypeRule(HengType.L2, "200", DraaiType.AR, 2, "01-03-02"),
    new HengTypeRule(HengType.L2, "300", DraaiType.AR, 2, "01-03-03"),
    new HengTypeRule(HengType.L2, "300", DraaiType.AR, 2, "70-10-41"),
    new HengTypeRule(HengType.L2, "300", DraaiType.AR, 2, "30-10-01"),
    new HengTypeRule(HengType.L2, "400", DraaiType.AR, 2, "01-03-04"),
    new HengTypeRule(HengType.L2, "400", DraaiType.AR, 4, "70-10-41"),
    new HengTypeRule(HengType.L2, "400", DraaiType.AR, 4, "30-10-01"),
    new HengTypeRule(HengType.L2, "500", DraaiType.AR, 2, "01-03-05"),
    new HengTypeRule(HengType.L2, "500", DraaiType.AR, 6, "70-10-41"),
    new HengTypeRule(HengType.L2, "500", DraaiType.AR, 6, "30-10-01"),
    new HengTypeRule(HengType.L2, "600", DraaiType.AR, 2, "01-03-06"),
    new HengTypeRule(HengType.L2, "600", DraaiType.AR, 8, "70-10-41"),
    new HengTypeRule(HengType.L2, "600", DraaiType.AR, 8, "30-10-01"),

    new HengTypeRule(HengType.L2, null, DraaiType.B, 2, "00-02-01"),
    new HengTypeRule(HengType.L2, null, DraaiType.B, 2, "01-01-10"),
    new HengTypeRule(HengType.L2, null, DraaiType.B, 2, "01-01-11"),
    new HengTypeRule(HengType.L2, null, DraaiType.B, 4, "70-10-41"),
    new HengTypeRule(HengType.L2, null, DraaiType.B, 4, "70-10-45"),
    new HengTypeRule(HengType.L2, null, DraaiType.B, 4, "70-90-12"),
    new HengTypeRule(HengType.L2, null, DraaiType.B, 8, "30-10-01"),
    new HengTypeRule(HengType.L2, "200", DraaiType.B, 4, "01-03-02"),
    new HengTypeRule(HengType.L2, "300", DraaiType.B, 4, "01-03-03"),
    new HengTypeRule(HengType.L2, "300", DraaiType.B, 4, "70-10-41"),
    new HengTypeRule(HengType.L2, "300", DraaiType.B, 4, "30-10-01"),
    new HengTypeRule(HengType.L2, "400", DraaiType.B, 4, "01-03-04"),
    new HengTypeRule(HengType.L2, "400", DraaiType.B, 8, "70-10-41"),
    new HengTypeRule(HengType.L2, "400", DraaiType.B, 8, "30-10-01"),
    new HengTypeRule(HengType.L2, "500", DraaiType.B, 4, "01-03-05"),
    new HengTypeRule(HengType.L2, "500", DraaiType.B, 12, "70-10-41"),
    new HengTypeRule(HengType.L2, "500", DraaiType.B, 12, "30-10-01"),
    new HengTypeRule(HengType.L2, "600", DraaiType.B, 4, "01-03-06"),
    new HengTypeRule(HengType.L2, "600", DraaiType.B, 16, "70-10-41"),
    new HengTypeRule(HengType.L2, "600", DraaiType.B, 16, "30-10-01"),

    new HengTypeRule(HengType.L3, null, null, 3, "00-02-01"),
    new HengTypeRule(HengType.L3, null, null, 6, "70-10-41"),
    new HengTypeRule(HengType.L3, null, null, 6, "70-10-45"),
    new HengTypeRule(HengType.L3, null, null, 6, "70-90-12"),
    new HengTypeRule(HengType.L3, null, null, 12, "30-10-01"),

    new HengTypeRule(HengType.L3, null, DraaiType.AL, 3, "01-01-10"),
    new HengTypeRule(HengType.L3, "200", DraaiType.AL, 3, "01-03-02"),
    new HengTypeRule(HengType.L3, "300", DraaiType.AL, 3, "01-03-03"),
    new HengTypeRule(HengType.L3, "300", DraaiType.AL, 3, "70-10-41"),
    new HengTypeRule(HengType.L3, "300", DraaiType.AL, 3, "30-10-01"),
    new HengTypeRule(HengType.L3, "400", DraaiType.AL, 3, "01-03-04"),
    new HengTypeRule(HengType.L3, "400", DraaiType.AL, 6, "70-10-41"),
    new HengTypeRule(HengType.L3, "400", DraaiType.AL, 6, "30-10-01"),
    new HengTypeRule(HengType.L3, "500", DraaiType.AL, 3, "01-03-05"),
    new HengTypeRule(HengType.L3, "500", DraaiType.AL, 9, "70-10-41"),
    new HengTypeRule(HengType.L3, "500", DraaiType.AL, 9, "30-10-01"),
    new HengTypeRule(HengType.L3, "600", DraaiType.AL, 3, "01-03-06"),
    new HengTypeRule(HengType.L3, "600", DraaiType.AL, 12, "70-10-41"),
    new HengTypeRule(HengType.L3, "600", DraaiType.AL, 12, "30-10-01"),

    new HengTypeRule(HengType.L3, null, DraaiType.AR, 3, "01-01-11"),
    new HengTypeRule(HengType.L3, "200", DraaiType.AR, 3, "01-03-02"),
    new HengTypeRule(HengType.L3, "300", DraaiType.AR, 3, "01-03-03"),
    new HengTypeRule(HengType.L3, "300", DraaiType.AR, 3, "70-10-41"),
    new HengTypeRule(HengType.L3, "300", DraaiType.AR, 3, "30-10-01"),
    new HengTypeRule(HengType.L3, "400", DraaiType.AR, 3, "01-03-04"),
    new HengTypeRule(HengType.L3, "400", DraaiType.AR, 6, "70-10-41"),
    new HengTypeRule(HengType.L3, "400", DraaiType.AR, 6, "30-10-01"),
    new HengTypeRule(HengType.L3, "500", DraaiType.AR, 3, "01-03-05"),
    new HengTypeRule(HengType.L3, "500", DraaiType.AR, 9, "70-10-41"),
    new HengTypeRule(HengType.L3, "500", DraaiType.AR, 9, "30-10-01"),
    new HengTypeRule(HengType.L3, "600", DraaiType.AR, 3, "01-03-06"),
    new HengTypeRule(HengType.L3, "600", DraaiType.AR, 12, "70-10-41"),
    new HengTypeRule(HengType.L3, "600", DraaiType.AR, 12, "30-10-01"),

    new HengTypeRule(HengType.L3, null, DraaiType.B, 3, "00-02-01"),
    new HengTypeRule(HengType.L3, null, DraaiType.B, 3, "01-01-10"),
    new HengTypeRule(HengType.L3, null, DraaiType.B, 3, "01-01-11"),
    new HengTypeRule(HengType.L3, null, DraaiType.B, 6, "70-10-41"),
    new HengTypeRule(HengType.L3, null, DraaiType.B, 6, "70-10-45"),
    new HengTypeRule(HengType.L3, null, DraaiType.B, 6, "70-90-12"),
    new HengTypeRule(HengType.L3, null, DraaiType.B, 12, "30-10-01"),
    new HengTypeRule(HengType.L3, "200", DraaiType.B, 6, "01-03-02"),
    new HengTypeRule(HengType.L3, "300", DraaiType.B, 6, "01-03-03"),
    new HengTypeRule(HengType.L3, "300", DraaiType.B, 6, "70-10-41"),
    new HengTypeRule(HengType.L3, "300", DraaiType.B, 6, "30-10-01"),
    new HengTypeRule(HengType.L3, "400", DraaiType.B, 6, "01-03-04"),
    new HengTypeRule(HengType.L3, "400", DraaiType.B, 12, "70-10-41"),
    new HengTypeRule(HengType.L3, "400", DraaiType.B, 12, "30-10-01"),
    new HengTypeRule(HengType.L3, "500", DraaiType.B, 6, "01-03-05"),
    new HengTypeRule(HengType.L3, "500", DraaiType.B, 18, "70-10-41"),
    new HengTypeRule(HengType.L3, "500", DraaiType.B, 18, "30-10-01"),
    new HengTypeRule(HengType.L3, "600", DraaiType.B, 6, "01-03-06"),
    new HengTypeRule(HengType.L3, "600", DraaiType.B, 24, "70-10-41"),
    new HengTypeRule(HengType.L3, "600", DraaiType.B, 24, "30-10-01"),

    new HengTypeRule(HengType.H2, null, null, 2, "00-02-01"),
    new HengTypeRule(HengType.H2, null, null, 8, "70-10-41"),
    new HengTypeRule(HengType.H2, null, null, 4, "70-10-45"),
    new HengTypeRule(HengType.H2, null, null, 4, "70-90-12"),
    new HengTypeRule(HengType.H2, null, null, 12, "30-10-01"),

    new HengTypeRule(HengType.H2, null, DraaiType.AL, 2, "01-01-10"),
    new HengTypeRule(HengType.H2, null, DraaiType.AL, 1, "01-11-01"),

    new HengTypeRule(HengType.H2, null, DraaiType.AR, 2, "01-01-11"),
    new HengTypeRule(HengType.H2, null, DraaiType.AR, 1, "01-11-02"),

    new HengTypeRule(HengType.H2, null, DraaiType.B, 2, "00-02-01"),
    new HengTypeRule(HengType.H2, null, DraaiType.B, 2, "01-01-10"),
    new HengTypeRule(HengType.H2, null, DraaiType.B, 2, "01-01-11"),
    new HengTypeRule(HengType.H2, null, DraaiType.B, 1, "01-11-01"),
    new HengTypeRule(HengType.H2, null, DraaiType.B, 1, "01-11-02"),
    new HengTypeRule(HengType.H2, null, DraaiType.B, 8, "70-10-41"),
    new HengTypeRule(HengType.H2, null, DraaiType.B, 4, "70-10-45"),
    new HengTypeRule(HengType.H2, null, DraaiType.B, 4, "70-90-12"),
    new HengTypeRule(HengType.H2, null, DraaiType.B, 12, "30-10-01"),

    new HengTypeRule(HengType.HT3, null, null, 3, "00-02-01"),
    new HengTypeRule(HengType.HT3, null, null, 10, "70-10-41"),
    new HengTypeRule(HengType.HT3, null, null, 6, "70-10-45"),
    new HengTypeRule(HengType.HT3, null, null, 6, "70-90-12"),
    new HengTypeRule(HengType.HT3, null, null, 16, "30-10-01"),

    new HengTypeRule(HengType.HT3, null, DraaiType.AL, 2, "01-01-10"),
    new HengTypeRule(HengType.HT3, null, DraaiType.AL, 1, "01-07-01"),
    new HengTypeRule(HengType.HT3, null, DraaiType.AL, 1, "01-11-01"),

    new HengTypeRule(HengType.HT3, null, DraaiType.AR, 2, "01-01-11"),
    new HengTypeRule(HengType.HT3, null, DraaiType.AR, 1, "01-07-02"),
    new HengTypeRule(HengType.HT3, null, DraaiType.AR, 1, "01-11-02"),

    new HengTypeRule(HengType.HT3, null, DraaiType.B, 3, "00-02-01"),
    new HengTypeRule(HengType.HT3, null, DraaiType.B, 3, "01-01-10"),
    new HengTypeRule(HengType.HT3, null, DraaiType.B, 3, "01-01-11"),
    new HengTypeRule(HengType.HT3, null, DraaiType.B, 1, "01-07-01"),
    new HengTypeRule(HengType.HT3, null, DraaiType.B, 1, "01-07-02"),
    new HengTypeRule(HengType.HT3, null, DraaiType.B, 1, "01-11-01"),
    new HengTypeRule(HengType.HT3, null, DraaiType.B, 1, "01-11-02"),
    new HengTypeRule(HengType.HT3, null, DraaiType.B, 10, "70-10-41"),
    new HengTypeRule(HengType.HT3, null, DraaiType.B, 6, "70-10-45"),
    new HengTypeRule(HengType.HT3, null, DraaiType.B, 6, "70-90-12"),
    new HengTypeRule(HengType.HT3, null, DraaiType.B, 16, "30-10-01"),
];

const LuiksluitingRules: LuiksluitingRule[] = [
    new LuiksluitingRule(Luiksluiting.TYPE_A, [DraaiType.AL, DraaiType.AR], 1, "60-02-01"),
    new LuiksluitingRule(Luiksluiting.TYPE_A, [DraaiType.AL, DraaiType.AR], 4, "70-30-12"),
    new LuiksluitingRule(Luiksluiting.TYPE_A, [DraaiType.AL, DraaiType.AR], 2, "70-30-15"),
    new LuiksluitingRule(Luiksluiting.TYPE_A, [DraaiType.AL, DraaiType.AR], 2, "70-90-06"),
    new LuiksluitingRule(Luiksluiting.TYPE_A, [DraaiType.B], 1, "60-02-01"),
    new LuiksluitingRule(Luiksluiting.TYPE_A, [DraaiType.B], 6, "70-30-12"),

    new LuiksluitingRule(Luiksluiting.TYPE_D, [DraaiType.AL, DraaiType.AR], 1, "60-06-01"),
    new LuiksluitingRule(Luiksluiting.TYPE_D, [DraaiType.AL, DraaiType.AR], 2, "70-30-12"),
    new LuiksluitingRule(Luiksluiting.TYPE_D, [DraaiType.AL, DraaiType.AR], 2, "70-30-15"),
    new LuiksluitingRule(Luiksluiting.TYPE_D, [DraaiType.AL, DraaiType.AR], 2, "70-90-06"),
    new LuiksluitingRule(Luiksluiting.TYPE_D, [DraaiType.B], 1, "60-06-01"),
    new LuiksluitingRule(Luiksluiting.TYPE_D, [DraaiType.B], 4, "70-30-12"),

    new LuiksluitingRule(Luiksluiting.MACO, [DraaiType.AL, DraaiType.AR], 1, "60-05-01"),
    new LuiksluitingRule(Luiksluiting.MACO, [DraaiType.AL, DraaiType.AR], 3, "70-30-12"),
    new LuiksluitingRule(Luiksluiting.MACO, [DraaiType.AL, DraaiType.AR], 2, "70-30-15"),
    new LuiksluitingRule(Luiksluiting.MACO, [DraaiType.AL, DraaiType.AR], 2, "70-90-06"),
    new LuiksluitingRule(Luiksluiting.MACO, [DraaiType.B], 1, "60-05-01"),
    new LuiksluitingRule(Luiksluiting.MACO, [DraaiType.B], 5, "70-30-12"),

    new LuiksluitingRule(Luiksluiting.TRADITIONEEL, [DraaiType.AL, DraaiType.AR], 1, "60-01-01"),
    new LuiksluitingRule(Luiksluiting.TRADITIONEEL, [DraaiType.AL, DraaiType.AR], 2, "70-10-41"),
    new LuiksluitingRule(Luiksluiting.TRADITIONEEL, [DraaiType.AL, DraaiType.AR], 2, "70-10-45"),
    new LuiksluitingRule(Luiksluiting.TRADITIONEEL, [DraaiType.AL, DraaiType.AR], 4, "30-10-01"),
    new LuiksluitingRule(Luiksluiting.TRADITIONEEL, [DraaiType.AL, DraaiType.AR], 2, "70-90-12"),
    new LuiksluitingRule(Luiksluiting.TRADITIONEEL, [DraaiType.B], 1, "60-01-01"),
    new LuiksluitingRule(Luiksluiting.TRADITIONEEL, [DraaiType.B], 4, "70-10-41"),
    new LuiksluitingRule(Luiksluiting.TRADITIONEEL, [DraaiType.B], 4, "30-10-01"),

    new LuiksluitingRule(Luiksluiting.OUDHOLLANDS, [DraaiType.AL, DraaiType.AR], 1, "60-03-02"),
    new LuiksluitingRule(Luiksluiting.OUDHOLLANDS, [DraaiType.AL, DraaiType.AR], 2, "70-10-41"),
    new LuiksluitingRule(Luiksluiting.OUDHOLLANDS, [DraaiType.AL, DraaiType.AR], 2, "70-10-45"),
    new LuiksluitingRule(Luiksluiting.OUDHOLLANDS, [DraaiType.AL, DraaiType.AR], 4, "30-10-01"),
    new LuiksluitingRule(Luiksluiting.OUDHOLLANDS, [DraaiType.AL, DraaiType.AR], 2, "70-90-12"),
    new LuiksluitingRule(Luiksluiting.OUDHOLLANDS, [DraaiType.B], 1, "60-03-02"),
    new LuiksluitingRule(Luiksluiting.OUDHOLLANDS, [DraaiType.B], 4, "70-10-41"),
    new LuiksluitingRule(Luiksluiting.OUDHOLLANDS, [DraaiType.B], 4, "30-10-01"),
];

const LuikvastzetterRules: LuikvastzetterRule[] = [
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_16_30, [DraaiType.AL, DraaiType.AR], 1, "50-09-02"),
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_16_30, [DraaiType.AL, DraaiType.AR], 1, "50-43-01"),
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_16_30, [DraaiType.AL, DraaiType.AR], 1, "70-90-14"),
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_16_30, [DraaiType.B], 2, "50-09-02"),
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_16_30, [DraaiType.B], 2, "50-43-01"),
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_16_30, [DraaiType.B], 2, "70-90-14"),

    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_30_55, [DraaiType.AL, DraaiType.AR], 1, "50-09-02"),
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_30_55, [DraaiType.AL, DraaiType.AR], 1, "50-08-01"),
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_30_55, [DraaiType.AL, DraaiType.AR], 1, "70-90-14"),
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_30_55, [DraaiType.B], 2, "50-09-02"),
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_30_55, [DraaiType.B], 2, "50-08-01"),
    new LuikvastzetterRule(Luikvastzetter.HERDERINNEKOPJE_TYPE_B_30_55, [DraaiType.B], 2, "70-90-14"),

    new LuikvastzetterRule(Luikvastzetter.HOLLANDSE_LUIKWERVEL, [DraaiType.AL, DraaiType.AR], 1, "50-02-01"),
    new LuikvastzetterRule(Luikvastzetter.HOLLANDSE_LUIKWERVEL, [DraaiType.AL, DraaiType.AR], 1, "50-08-01"),
    new LuikvastzetterRule(Luikvastzetter.HOLLANDSE_LUIKWERVEL, [DraaiType.AL, DraaiType.AR], 1, "70-90-14"),
    new LuikvastzetterRule(Luikvastzetter.HOLLANDSE_LUIKWERVEL, [DraaiType.B], 2, "50-02-01"),
    new LuikvastzetterRule(Luikvastzetter.HOLLANDSE_LUIKWERVEL, [DraaiType.B], 2, "50-08-01"),
    new LuikvastzetterRule(Luikvastzetter.HOLLANDSE_LUIKWERVEL, [DraaiType.B], 2, "70-90-14"),

    new LuikvastzetterRule(Luikvastzetter.LUIKWERVEL_MARSEILLE, [DraaiType.AL, DraaiType.AR], 1, "50-03-03"),
    new LuikvastzetterRule(Luikvastzetter.LUIKWERVEL_MARSEILLE, [DraaiType.AL, DraaiType.AR], 1, "50-08-01"),
    new LuikvastzetterRule(Luikvastzetter.LUIKWERVEL_MARSEILLE, [DraaiType.AL, DraaiType.AR], 1, "70-90-14"),
    new LuikvastzetterRule(Luikvastzetter.LUIKWERVEL_MARSEILLE, [DraaiType.B], 2, "50-03-03"),
    new LuikvastzetterRule(Luikvastzetter.LUIKWERVEL_MARSEILLE, [DraaiType.B], 2, "50-08-01"),
    new LuikvastzetterRule(Luikvastzetter.LUIKWERVEL_MARSEILLE, [DraaiType.B], 2, "70-90-14"),

    new LuikvastzetterRule(Luikvastzetter.VERBORGEN_LUIKVASTZETTER_MACO, [DraaiType.AL, DraaiType.AR], 1, "50-07-01"),
    new LuikvastzetterRule(Luikvastzetter.VERBORGEN_LUIKVASTZETTER_MACO, [DraaiType.B], 2, "50-07-01"),

    new LuikvastzetterRule(Luikvastzetter.AUTOMATISCHE_LUIKVASTZETTER_ZWART, [DraaiType.AL, DraaiType.AR], 1, "50-05-01"),
    new LuikvastzetterRule(Luikvastzetter.AUTOMATISCHE_LUIKVASTZETTER_ZWART, [DraaiType.B], 2, "50-05-01"),

    new LuikvastzetterRule(Luikvastzetter.COMFORT_SLUITING, [DraaiType.AL, DraaiType.AR], 1, "50-60-01"),
    new LuikvastzetterRule(Luikvastzetter.COMFORT_SLUITING, [DraaiType.B], 2, "50-60-01"),
];

export class Item {
    constructor(id, name, amount, remark) {
        this._id = id;
        this._name = name;
        this._amount = amount;
        this._remark = remark;
    }

    getDeepCopy() {
        const t = JSON.parse(JSON.stringify({
            id: this._id,
            name: this._name,
            amount: this._amount,
            remark: this._remark,
        }));
        return new Item(t.id, t.name, t.amount, t.remark);
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    get remark() {
        return this._remark;
    }

    set remark(value) {
        this._remark = value;
    }
}

const ProductList = {
    "00-01-01": new Item("00-01-01", "schroefduim 100mm", 0, ""),
    "00-01-02": new Item("00-01-02", "schroefduim 150mm", 0, ""),
    "00-01-03": new Item("00-01-03", "schroefduim 200mm", 0, ""),
    "00-02-01": new Item("00-02-01", "losse kunststof duimstift 18mm", 0, ""),
    "01-01-10": new Item("01-01-10", "traditionele plaatduim muurmontage, links", 0, ""),
    "01-01-11": new Item("01-01-11", "traditionele plaatduim muurmontage, rechts", 0, ""),
    "01-03-02": new Item("01-03-02", "traditioneel staartgeheng, recht, 210mm", 0, ""),
    "01-03-03": new Item("01-03-03", "traditioneel staartgeheng, recht, 310mm", 0, ""),
    "01-03-04": new Item("01-03-04", "traditioneel staartgeheng, recht, 410mm", 0, ""),
    "01-03-05": new Item("01-03-05", "traditioneel staartgeheng, recht, 510mm", 0, ""),
    "01-03-06": new Item("01-03-06", "traditioneel staartgeheng, recht, 610mm", 0, ""),
    "01-03-07": new Item("01-03-07", "traditioneel staartgeheng, recht, 710mm", 0, ""),
    "01-03-08": new Item("01-03-08", "traditioneel staartgeheng, recht, 810mm", 0, ""),
    "01-05-01": new Item("01-05-01", "traditioneel staartgeheng, verzet 28mm, 200mm", 0, ""),
    "01-05-02": new Item("01-05-02", "traditioneel staartgeheng, verzet 28mm, 300mm", 0, ""),
    "01-05-03": new Item("01-05-03", "traditioneel staartgeheng, verzet 28mm, 400mm", 0, ""),
    "01-05-04": new Item("01-05-04", "traditioneel staartgeheng, verzet 28mm, 500mm", 0, ""),
    "01-05-05": new Item("01-05-05", "traditioneel staartgeheng, verzet 28mm, 600mm", 0, ""),
    "01-05-06": new Item("01-05-06", "traditioneel staartgeheng, verzet 28mm, 700mm", 0, ""),
    "01-05-07": new Item("01-05-07", "traditioneel staartgeheng, verzet 28mm, 800mm", 0, ""),
    "01-05-08": new Item("01-05-08", "traditioneel staartgeheng, verzet 37mm, 190mm", 0, ""),
    "01-05-09": new Item("01-05-09", "traditioneel staartgeheng, verzet 37mm, 290mm", 0, ""),
    "01-05-10": new Item("01-05-10", "traditioneel staartgeheng, verzet 37mm, 390mm", 0, ""),
    "01-05-11": new Item("01-05-11", "traditioneel staartgeheng, verzet 37mm, 490mm", 0, ""),
    "01-05-12": new Item("01-05-12", "traditioneel staartgeheng, verzet 37mm, 590mm", 0, ""),
    "01-05-13": new Item("01-05-13", "traditioneel staartgeheng, verzet 37mm, 690mm", 0, ""),
    "01-05-14": new Item("01-05-14", "traditioneel staartgeheng, verzet 37mm, 790mm", 0, ""),
    "01-05-15": new Item("01-05-15", "traditioneel staartgeheng, verzet 57mm, 170mm", 0, ""),
    "01-05-16": new Item("01-05-16", "traditioneel staartgeheng, verzet 57mm, 270mm", 0, ""),
    "01-05-17": new Item("01-05-17", "traditioneel staartgeheng, verzet 57mm, 370mm", 0, ""),
    "01-05-18": new Item("01-05-18", "traditioneel staartgeheng, verzet 57mm, 470mm", 0, ""),
    "01-05-19": new Item("01-05-19", "traditioneel staartgeheng, verzet 57mm, 570mm", 0, ""),
    "01-05-20": new Item("01-05-20", "traditioneel staartgeheng, verzet 57mm, 670mm", 0, ""),
    "01-05-21": new Item("01-05-21", "traditioneel staartgeheng, verzet 57mm, 770mm", 0, ""),
    "01-07-01": new Item("01-07-01", "traditioneel T geheng, recht, maat E= 30mm, links", 0, ""),
    "01-07-02": new Item("01-07-02", "traditioneel T geheng, recht, maat E= 30mm, rechts", 0, ""),
    "01-07-03": new Item("01-07-03", "traditioneel T geheng, recht, maat E= 40mm, links", 0, ""),
    "01-07-04": new Item("01-07-04", "traditioneel T geheng, recht, maat E= 40mm, rechts", 0, ""),
    "01-07-05": new Item("01-07-05", "traditioneel T geheng, recht, maat E= 50mm, links", 0, ""),
    "01-07-06": new Item("01-07-06", "traditioneel T geheng, recht, maat E= 50mm, rechts", 0, ""),
    "01-07-07": new Item("01-07-07", "traditioneel T geheng, recht, maat E= 70mm, links", 0, ""),
    "01-07-08": new Item("01-07-08", "traditioneel T geheng, recht, maat E= 70mm, rechts", 0, ""),
    "01-09-01": new Item("01-09-01", "traditioneel T geheng, verzet 28mm, maat E= 60mm, links", 0, ""),
    "01-09-02": new Item("01-09-02", "traditioneel T geheng, verzet 28mm, maat E= 60mm, rechts", 0, ""),
    "01-09-03": new Item("01-09-03", "traditioneel T geheng, verzet 37mm, maat E= 50mm, links", 0, ""),
    "01-09-04": new Item("01-09-04", "traditioneel T geheng, verzet 37mm, maat E= 50mm, rechts", 0, ""),
    "01-09-05": new Item("01-09-05", "traditioneel T geheng, verzet 57mm, maat E= 30mm, links", 0, ""),
    "01-09-06": new Item("01-09-06", "traditioneel T geheng, verzet 57mm, maat E= 30mm, rechts", 0, ""),
    "01-11-01": new Item("01-11-01", "traditioneel hoekgeheng, set, recht, maat E= 30mm, links", 0, ""),
    "01-11-02": new Item("01-11-02", "traditioneel hoekgeheng, set, recht, maat E= 30mm, rechts", 0, ""),
    "01-11-03": new Item("01-11-03", "traditioneel hoekgeheng, set, recht, maat E= 50mm, links", 0, ""),
    "01-11-04": new Item("01-11-04", "traditioneel hoekgeheng, set, recht, maat E= 50mm, rechts", 0, ""),
    "01-11-05": new Item("01-11-05", "traditioneel hoekgeheng, set, recht, maat E= 70mm, links", 0, ""),
    "01-11-06": new Item("01-11-06", "traditioneel hoekgeheng, set, recht, maat E= 70mm, rechts", 0, ""),
    "01-13-01": new Item("01-13-01", "traditioneel hoekgeheng, set, verzet 28mm, maat E= 60mm, links", 0, ""),
    "01-13-02": new Item("01-13-02", "traditioneel hoekgeheng, set, verzet 28mm, maat E= 60mm, rechts", 0, ""),
    "01-13-03": new Item("01-13-03", "traditioneel hoekgeheng, set, verzet 37mm, maat E= 50mm, links", 0, ""),
    "01-13-04": new Item("01-13-04", "traditioneel hoekgeheng, set, verzet 37mm, maat E= 50mm, rechts", 0, ""),
    "01-13-05": new Item("01-13-05", "traditioneel hoekgeheng, set, verzet 57mm, maat E= 30mm, links", 0, ""),
    "01-13-06": new Item("01-13-06", "traditioneel hoekgeheng, set, verzet 57mm, maat E= 30mm, rechts", 0, ""),
    "01-17-10": new Item("01-17-10", "sierplaat traditioneel", 0, ""),
    "01-18-01": new Item("01-18-01", "traditioneel vouwluikscharnier linksdraaiend (set)", 0, ""),
    "01-18-02": new Item("01-18-02", "traditioneel vouwluikscharnier rechtsdraaiend (set)", 0, ""),
    "01-50-01": new Item("01-50-01", "traditioneel luikbeslag, complete set, dubbel luik, muurmontage", 0, ""),
    "01-50-02": new Item("01-50-02", "traditioneel luikbeslag, complete set, enkel luik, links, muurmontage", 0, ""),
    "01-50-03": new Item("01-50-03", "traditioneel luikbeslag, complete set, enkel luik, rechts, muurmontage", 0, ""),
    "01-50-51": new Item("01-50-51", "traditioneel luikbeslag, Marseille, set, dubbel luik, muurmontage", 0, ""),
    "02-01-10": new Item("02-01-10", "Oudhollandse plaatduim muurmontage, links", 0, ""),
    "02-01-11": new Item("02-01-11", "Oudhollandse plaatduim muurmontage, rechts", 0, ""),
    "02-03-02": new Item("02-03-02", "Oudhollandse staartgeheng, recht, 210mm", 0, ""),
    "02-03-03": new Item("02-03-03", "Oudhollandse staartgeheng, recht, 310mm", 0, ""),
    "02-03-04": new Item("02-03-04", "Oudhollandse staartgeheng, recht, 410mm", 0, ""),
    "02-03-05": new Item("02-03-05", "Oudhollandse staartgeheng, recht, 510mm", 0, ""),
    "02-03-06": new Item("02-03-06", "Oudhollandse staartgeheng, recht, 610mm", 0, ""),
    "02-03-07": new Item("02-03-07", "Oudhollandse staartgeheng, recht, 710mm", 0, ""),
    "02-03-08": new Item("02-03-08", "Oudhollandse staartgeheng, recht, 810mm", 0, ""),
    "02-05-01": new Item("02-05-01", "Oudhollandse staartgeheng, verzet 28mm, 200mm", 0, ""),
    "02-05-02": new Item("02-05-02", "Oudhollandse staartgeheng, verzet 28mm, 300mm", 0, ""),
    "02-05-03": new Item("02-05-03", "Oudhollandse staartgeheng, verzet 28mm, 400mm", 0, ""),
    "02-05-04": new Item("02-05-04", "Oudhollandse staartgeheng, verzet 28mm, 500mm", 0, ""),
    "02-05-05": new Item("02-05-05", "Oudhollandse staartgeheng, verzet 28mm, 600mm", 0, ""),
    "02-05-06": new Item("02-05-06", "Oudhollandse staartgeheng, verzet 28mm, 700mm", 0, ""),
    "02-05-07": new Item("02-05-07", "Oudhollandse staartgeheng, verzet 28mm, 800mm", 0, ""),
    "02-05-08": new Item("02-05-08", "Oudhollandse staartgeheng, verzet 37mm, 190mm", 0, ""),
    "02-05-09": new Item("02-05-09", "Oudhollandse staartgeheng, verzet 37mm, 290mm", 0, ""),
    "02-05-10": new Item("02-05-10", "Oudhollandse staartgeheng, verzet 37mm, 390mm", 0, ""),
    "02-05-11": new Item("02-05-11", "Oudhollandse staartgeheng, verzet 37mm, 490mm", 0, ""),
    "02-05-12": new Item("02-05-12", "Oudhollandse staartgeheng, verzet 37mm, 590mm", 0, ""),
    "02-05-13": new Item("02-05-13", "Oudhollandse staartgeheng, verzet 37mm, 690mm", 0, ""),
    "02-05-14": new Item("02-05-14", "Oudhollandse staartgeheng, verzet 37mm, 790mm", 0, ""),
    "02-05-15": new Item("02-05-15", "Oudhollandse staartgeheng, verzet 57mm, 170mm", 0, ""),
    "02-05-16": new Item("02-05-16", "Oudhollandse staartgeheng, verzet 57mm, 270mm", 0, ""),
    "02-05-17": new Item("02-05-17", "Oudhollandse staartgeheng, verzet 57mm, 370mm", 0, ""),
    "02-05-18": new Item("02-05-18", "Oudhollandse staartgeheng, verzet 57mm, 470mm", 0, ""),
    "02-05-19": new Item("02-05-19", "Oudhollandse staartgeheng, verzet 57mm, 570mm", 0, ""),
    "02-05-20": new Item("02-05-20", "Oudhollandse staartgeheng, verzet 57mm, 670mm", 0, ""),
    "02-05-21": new Item("02-05-21", "Oudhollandse staartgeheng, verzet 57mm, 770mm", 0, ""),
    "02-07-01": new Item("02-07-01", "Oudhollandse T geheng, recht, maat E= 30mm, links", 0, ""),
    "02-07-02": new Item("02-07-02", "Oudhollandse T geheng, recht, maat E= 30mm, rechts", 0, ""),
    "02-07-03": new Item("02-07-03", "Oudhollandse T geheng, recht, maat E= 40mm, links", 0, ""),
    "02-07-04": new Item("02-07-04", "Oudhollandse T geheng, recht, maat E= 40mm, rechts", 0, ""),
    "02-07-05": new Item("02-07-05", "Oudhollandse T geheng, recht, maat E= 50mm, links", 0, ""),
    "02-07-06": new Item("02-07-06", "Oudhollandse T geheng, recht, maat E= 50mm, rechts", 0, ""),
    "02-07-07": new Item("02-07-07", "Oudhollandse T geheng, recht, maat E= 70mm, links", 0, ""),
    "02-07-08": new Item("02-07-08", "Oudhollandse T geheng, recht, maat E= 70mm, rechts", 0, ""),
    "02-09-01": new Item("02-09-01", "Oudhollandse T geheng, verzet 28mm, maat E= 60mm, links", 0, ""),
    "02-09-02": new Item("02-09-02", "Oudhollandse T geheng, verzet 28mm, maat E= 60mm, rechts", 0, ""),
    "02-09-03": new Item("02-09-03", "Oudhollandse T geheng, verzet 37mm, maat E= 50mm, links", 0, ""),
    "02-09-04": new Item("02-09-04", "Oudhollandse T geheng, verzet 37mm, maat E= 50mm, rechts", 0, ""),
    "02-09-05": new Item("02-09-05", "Oudhollandse T geheng, verzet 57mm, maat E= 30mm, links", 0, ""),
    "02-09-06": new Item("02-09-06", "Oudhollandse T geheng, verzet 57mm, maat E= 30mm, rechts", 0, ""),
    "02-11-01": new Item("02-11-01", "Oudhollandse hoekgeheng, set, recht, maat E= 30mm, links", 0, ""),
    "02-11-02": new Item("02-11-02", "Oudhollandse hoekgeheng, set, recht, maat E= 30mm, rechts", 0, ""),
    "02-11-03": new Item("02-11-03", "Oudhollandse hoekgeheng, set, recht, maat E= 50mm, links", 0, ""),
    "02-11-04": new Item("02-11-04", "Oudhollandse hoekgeheng, set, recht, maat E= 50mm, rechts", 0, ""),
    "02-11-05": new Item("02-11-05", "Oudhollandse hoekgeheng, set, recht, maat E= 70mm, links", 0, ""),
    "02-11-06": new Item("02-11-06", "Oudhollandse hoekgeheng, set, recht, maat E= 70mm, rechts", 0, ""),
    "02-13-01": new Item("02-13-01", "Oudhollands hoekgeheng, set, verzet 28mm, maat E= 60mm, links", 0, ""),
    "02-13-02": new Item("02-13-02", "Oudhollands hoekgeheng, set, verzet 28mm, maat E= 60mm, rechts", 0, ""),
    "02-13-03": new Item("02-13-03", "Oudhollands hoekgeheng, set, verzet 37mm, maat E= 50mm, links", 0, ""),
    "02-13-04": new Item("02-13-04", "Oudhollands hoekgeheng, set, verzet 37mm, maat E= 50mm, rechts", 0, ""),
    "02-13-05": new Item("02-13-05", "Oudhollands hoekgeheng, set, verzet 57mm, maat E= 30mm, links", 0, ""),
    "02-13-06": new Item("02-13-06", "Oudhollands hoekgeheng, set, verzet 57mm, maat E= 30mm, rechts", 0, ""),
    "02-15-01": new Item("02-15-01", "Oudhollandse plaatduim links", 0, ""),
    "02-15-02": new Item("02-15-02", "Oudhollandse plaatduim rechts", 0, ""),
    "02-17-10": new Item("02-17-10", "sierplaat Oudhollands", 0, ""),
    "02-18-01": new Item("02-18-01", "Oudhollands vouwluikscharnier linksdraaiend ", 0, ""),
    "02-18-02": new Item("02-18-02", "Oudhollands vouwluikscharnier rechtsdraaiend ", 0, ""),
    "02-50-01": new Item("02-50-01", "Oudhollands luikbeslag, complete set, dubbel luik, muurmontage", 0, ""),
    "02-50-02": new Item("02-50-02", "Oudhollands luikbeslag, complete set, enkel luik, links, muurmontage", 0, ""),
    "02-50-03": new Item("02-50-03", "Oudhollands luikbeslag, complete set, enkel luik, rechts, muurmontage", 0, ""),
    "50-09-01": new Item("50-09-01", "herderinnekopje type B, 55mm", 0, ""),
    "50-09-02": new Item("50-09-02", "herderinnekopje type B, 75mm", 0, ""),
    "50-09-03": new Item("50-09-03", "herderinnekopje type B, 95mm", 0, ""),
    "50-09-04": new Item("50-09-04", "herderinnekopje type B, 125mm", 0, ""),
    "50-09-05": new Item("50-09-05", "herderinnekopje type B, 190mm", 0, ""),
    "50-10-01": new Item("50-10-01", "herderinnekopje type C, 50mm", 0, ""),
    "50-10-02": new Item("50-10-02", "herderinnekopje type C, 90mm", 0, ""),
    "50-02-01": new Item("50-02-01", "Hollandse luikwervel, 75mm", 0, ""),
    "50-02-03": new Item("50-02-03", "Hollandse luikwervel met schroef, 125mm", 0, ""),
    "50-02-10": new Item("50-02-10", "Hollandse luikwervel zonder schroef", 0, ""),
    "50-03-01": new Item("50-03-01", "luikwervel Marseille, 30mm", 0, ""),
    "50-03-02": new Item("50-03-02", "luikwervel Marseille, 50mm", 0, ""),
    "50-03-03": new Item("50-03-03", "luikwervel Marseille, 70mm", 0, ""),
    "50-03-05": new Item("50-03-05", "luikwervel Marseille, 110mm", 0, ""),
    "50-05-01": new Item("50-05-01", "automatische luikvastzetter zwart", 0, ""),
    "50-05-10": new Item("50-05-10", "automatische luikvastzetter wit", 0, ""),
    "50-06-01": new Item("50-06-01", "verborgen franse luikvastzetter ", 0, ""),
    "50-07-01": new Item("50-07-01", "verborgen luikvastzetter Maco ", 0, ""),
    "50-07-05": new Item("50-07-05", "vulplaat tbv luikvastzetter Maco 5mm", 0, ""),
    "50-08-01": new Item("50-08-01", "aanslag tbv luikvastzetter", 0, ""),
    "50-43-01": new Item("50-43-01", "aanslag voor luikwervel (voor dunne luiken)", 0, ""),
    "50-60-01": new Item("50-60-01", "comfort sluiting", 0, ""),
    "60-01-01": new Item("60-01-01", "middensluiting traditioneel", 0, ""),
    "60-03-02": new Item("60-03-02", "middensluiting Oudhollands", 0, ""),
    "60-02-01": new Item("60-02-01", "middensluiting type A, 175mm", 0, ""),
    "60-06-01": new Item("60-06-01", "middensluiting type D ", 0, ""),
    "60-05-01": new Item("60-05-01", "middensluiting Maco", 0, ""),
    "60-05-02": new Item("60-05-02", "vulplaat 5mm tbv middensluiting Maco ", 0, ""),
    "60-20-01": new Item("60-20-01", "sluiting enkel luik asymmetrisch", 0, ""),
    "70-10-10": new Item("70-10-10", "houtdraadbout, M8, 30mm, zwart gepoedercoat", 0, ""),
    "70-10-11": new Item("70-10-11", "houtdraadbout, M8, 35mm, zwart gepoedercoat", 0, ""),
    "70-10-12": new Item("70-10-12", "houtdraadbout, M8, 40mm, zwart gepoedercoat", 0, ""),
    "70-10-13": new Item("70-10-13", "houtdraadbout, M8, 50mm, zwart gepoedercoat", 0, ""),
    "70-10-14": new Item("70-10-14", "houtdraadbout, M8, 60mm, zwart gepoedercoat", 0, ""),
    "70-10-21": new Item("70-10-21", "houtdraadbout, M8, 30mm, zwart verzinkt", 0, ""),
    "70-10-22": new Item("70-10-22", "houtdraadbout, M8, 35mm, zwart verzinkt", 0, ""),
    "70-10-23": new Item("70-10-23", "houtdraadbout, M8, 40mm, zwart verzinkt", 0, ""),
    "70-10-24": new Item("70-10-24", "houtdraadbout, M8, 50mm, zwart verzinkt", 0, ""),
    "70-10-25": new Item("70-10-25", "houtdraadbout, M8, 60mm, zwart verzinkt", 0, ""),
    "70-10-31": new Item("70-10-31", "houtdraadbout, M8, 30mm, RVS", 0, ""),
    "70-10-32": new Item("70-10-32", "houtdraadbout, M8, 35mm, RVS", 0, ""),
    "70-10-33": new Item("70-10-33", "houtdraadbout, M8, 40mm, RVS", 0, ""),
    "70-10-34": new Item("70-10-34", "houtdraadbout, M8, 50mm, RVS", 0, ""),
    "70-10-35": new Item("70-10-35", "houtdraadbout, M8, 60mm, RVS", 0, ""),
    "70-10-41": new Item("70-10-41", "houtdraadbout, M8, 30mm, RVS, zwart gepoedercoat", 0, ""),
    "70-10-42": new Item("70-10-42", "houtdraadbout, M8, 35mm, RVS, zwart gepoedercoat", 0, ""),
    "70-10-43": new Item("70-10-43", "houtdraadbout, M8, 40mm, RVS, zwart gepoedercoat", 0, ""),
    "70-10-44": new Item("70-10-44", "houtdraadbout, M8, 50mm, RVS, zwart gepoedercoat", 0, ""),
    "70-10-45": new Item("70-10-45", "houtdraadbout, M8, 60mm, RVS, zwart gepoedercoat", 0, ""),
    "70-10-46": new Item("70-10-46", "houtdraadbout, M8, 70mm, RVS, zwart gepoedercoat", 0, ""),
    "70-15-01": new Item("70-15-01", "draadbout, M8, 19mm, voor kunststof/aluminium, zwart", 0, ""),
    "70-15-02": new Item("70-15-02", "draadbout, M8, 32mm, voor kunststof, zwart gepoedercoat", 0, ""),
    "70-20-13": new Item("70-20-13", "Slotbout met moer, DIN 603/555, M8, 50mm, zwart verzinkt", 0, ""),
    "70-20-14": new Item("70-20-14", "Slotbout met moer, DIN 603/555, M8, 60mm, zwart verzinkt", 0, ""),
    "70-30-10": new Item("70-30-10", "RVS schroef zwart gepoedercoat 4x16", 0, ""),
    "70-30-11": new Item("70-30-11", "RVS schroef zwart gepoedercoat 4x20", 0, ""),
    "70-30-12": new Item("70-30-12", "RVS schroef zwart gepoedercoat 4x25", 0, ""),
    "70-30-13": new Item("70-30-13", "RVS schroef zwart gepoedercoat 4x30", 0, ""),
    "70-30-14": new Item("70-30-14", "RVS schroef zwart gepoedercoat 4x35", 0, ""),
    "70-30-15": new Item("70-30-15", "RVS schroef zwart gepoedercoat 4x40", 0, ""),
    "70-30-16": new Item("70-30-16", "RVS schroef zwart gepoedercoat 4x45", 0, ""),
    "70-30-17": new Item("70-30-17", "RVS schroef zwart gepoedercoat 4x50", 0, ""),
    "70-90-05": new Item("70-90-05", "plug 5mm", 0, ""),
    "70-90-06": new Item("70-90-06", "plug 6mm", 0, ""),
    "70-90-08": new Item("70-90-08", "plug 8mm", 0, ""),
    "70-90-10": new Item("70-90-10", "plug 10mm", 0, ""),
    "70-90-12": new Item("70-90-12", "plug 12mm", 0, ""),
    "70-90-14": new Item("70-90-14", "plug 14mm", 0, ""),
    "70-90-16": new Item("70-90-16", "plug16mm", 0, ""),
    "80-01-02": new Item("80-01-02", "inmetselduim horizontaal ", 0, ""),
    "80-02-01": new Item("80-02-01", "kunststof afdekhuls", 0, ""),
    "80-02-02": new Item("80-02-02", "rozet", 0, ""),
    "80-03-01": new Item("80-03-01", "aanloopsteuntje ", 0, ""),
    "80-04-01": new Item("80-04-01", "ophanghaak voor vaste montage zwart gepoedercoat", 0, ""),
    "80-04-02": new Item("80-04-02", "ophanghaak voor vaste montage RVS", 0, ""),
    "80-04-03": new Item("80-04-03", "ophanghaak voor vaste montage RVS met montagemateriaal", 0, ""),
    "30-10-01": new Item("30-10-01", "kunststof beschermring tbv houtdraadbout of slotbouten M8", 0, ""),
    "90-10-01": new Item("90-10-01", "scharnier gelagerd met vaasknop 76x76", 0, ""),
    "90-10-02": new Item("90-10-02", "scharnier gelagerd met vaasknop 90x90", 0, ""),
    "14-10-01": new Item("14-10-01", "lakstift zwart", 0, ""),
};
